/* eslint-disable */
import { isObject, forOwn } from 'lodash';

export default class EventEmitter {
  constructor() {
    this.events = {};
  }

  on(event, listener, namespace) {
    if (!isObject(this.events[event])) {
      this.events[event] = {
        [namespace]: listener,
      };
    } else {
      this.events[event][namespace] = listener;
    }
  }

  off(event, namespace) {
    const namespaceName = namespace || 'default';
    if (isObject(this.events[event]) && isObject(this.events[event][namespaceName])) {
      delete (this.events[event], namespace);
    }
  }

  emit(event, payload) {
    const args = [].slice.call(arguments, 1);
    if (isObject(this.events[event])) {
      forOwn(this.events[event], (value, key) => {
        value.apply(this, args);
      });
    }
  }

  clearAllListeners(event, listener) {
    if (isObject(this.events[event])) {
      if (listener === undefined) {
        if (this.events[event]) {
          delete this.events[event];
        }
      } else {
        this.off(event, listener);
      }
    }
  }
}
